
var FrontBanner = function( elm )
{
	var settings = {};
	var _settings = JSON.parse( elm.attr( 'data-settings' ) );
	for ( var setting in _settings ) {
	    if ( _settings.hasOwnProperty( setting ) ) {
			var value = _settings[setting];
			var split = value.split('|');
			if( split.length === 2 ) {
				switch( split[0] ) {
					case 'bool' :
						settings[setting] = ( split[1] === 'true' );
					break;
					case 'int' :
						settings[setting] = parseInt( split[1] );
					break;
					case 'string' :
						settings[setting] = String( split[1] );
					break;
				}
			}
	    }
	}
	elm.data( 'owl-carousel-settings', settings );
	elm.owlCarousel( settings );
	elm.removeAttr( 'data-settings' );
};


jQuery(document).ready( function($){

	$('.front-banner').each(function(){
		new FrontBanner( $(this) );
	});

});